import { useEffect } from 'react'
import {
  Chart as ChartJS,
  TimeScale,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  BarElement,
  Title,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'
import 'chartjs-adapter-moment'

// Composants de graphiques
import ErSuperviseChart from './charts/ErSuperviseChart'
import MitreAttackChart from './charts/MitreAttackChart'
import PerimetreSuperviseChart from './charts/PerimetreSuperviseChart'
import LogChart from './charts/LogChart'

// Hooks et utilitaires
import { useChartData } from '../hooks/useChartData'
import { CHART_STYLES } from '../constants/chartConstants'

// Enregistrement des composants Chart.js
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  TimeScale,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
)

/**
 * Composant principal Chart - Refactorisé pour une meilleure lisibilité
 * 
 * Ce composant gère l'affichage des différents types de graphiques KPI.
 * Il utilise des hooks personnalisés et des composants modulaires pour :
 * - Séparer la logique de chaque type de graphique
 * - Gérer les configurations et thèmes
 * - Optimiser les performances
 */
function Chart(props) {
  const { kpiDocument, name, stacked, label } = props
  
  const {
    cyberchartState,
    chartLogData,
    chartLogOptions,
    updateLogChartData,
    setChartLogOptions
  } = useChartData(kpiDocument, name, stacked)

  // Mise à jour des options de graphique de logs quand la propriété stacked change
  useEffect(() => {
    if (typeof stacked === 'boolean' && chartLogOptions?.scales) {
      const updatedOptions = { ...chartLogOptions }
      updatedOptions.scales.y.stacked = stacked
      setChartLogOptions(updatedOptions)
      updateLogChartData(stacked)
    }
  }, [stacked]) // Suppression des dépendances qui causent la boucle infinie

  // Fonction pour déterminer quel graphique afficher
  const renderChart = () => {
    switch (name) {
      case 'er_supervise':
        return (
          <ErSuperviseChart
            data={cyberchartState.er_supervise?.data}
            options={cyberchartState.er_supervise?.options}
          />
        )
      
      case 'mitre_attack':
        return (
          <MitreAttackChart
            data={cyberchartState.mitre_attack?.data}
            options={cyberchartState.mitre_attack?.options}
          />
        )
      
      case 'perimetre_supervise':
        return (
          <PerimetreSuperviseChart
            data={cyberchartState.perimetre_supervise?.data}
            options={cyberchartState.perimetre_supervise?.options}
          />
        )
      
      case 'log_full':
      case 'log':
        return (
          <LogChart
            data={chartLogData}
            options={chartLogOptions}
          />
        )
      
      default:
        return null
    }
  }

  return (
    <>
      <div>
        {label}
      </div>
      <div className={CHART_STYLES.height300}>
        {renderChart()}
      </div>
    </>
  )
}

export default Chart